/**
 * Financial Forecast API service
 */

import apiClient from './api';

export interface ForecastQuestion {
  question: string;
  question_number: number;
  total_questions: number;
  all_complete?: boolean;
}

export interface ForecastMetadata {
  generated_at: string;
  status: string;
  sheets: string[];
}

export const financialForecastService = {
  async startQA(sessionId: string): Promise<any> {
    const response = await apiClient.post(`/api/sessions/${sessionId}/financial-forecast/start-qa`);
    return response.data;
  },

  async getCurrentQuestion(sessionId: string): Promise<ForecastQuestion> {
    const response = await apiClient.get(`/api/sessions/${sessionId}/financial-forecast/qa/current`);
    return response.data;
  },

  async submitAnswer(sessionId: string, answer: string): Promise<any> {
    const response = await apiClient.post(`/api/sessions/${sessionId}/financial-forecast/qa`, { answer });
    return response.data;
  },

  async generate(sessionId: string): Promise<any> {
    const response = await apiClient.post(`/api/sessions/${sessionId}/financial-forecast/generate`);
    return response.data;
  },

  async getMetadata(sessionId: string): Promise<ForecastMetadata> {
    const response = await apiClient.get(`/api/sessions/${sessionId}/financial-forecast`);
    return response.data;
  },

  getDownloadUrl(sessionId: string): string {
    return `${apiClient.defaults.baseURL}/api/sessions/${sessionId}/financial-forecast/download`;
  },
};

export default financialForecastService;
